import { CallDirectionKeys } from './call-direction.enum';

export const CALL_DIRECTIONS_LOOKUP = [
  { value: CallDirectionKeys.inbound, description: 'Inbound' },
  { value: CallDirectionKeys.outbound, description: 'Outbound' },
];
